function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("g", {
  id: "Icon"
}, /*#__PURE__*/React.createElement("title", null, "HD_Icons_Ivonne_Final"), /*#__PURE__*/React.createElement("path", {
  d: "M241 119.9V49h-99.2v21.3H0v142.3h42.4v70.9h241V119.9H241zM28.5 184V98.8h141.8V77.6h42.1v42.3h-28.2v21.3H42.4V184H28.5zm226.4 70.9H71v-85.2h141.8v-21.3h42.1v106.5z"
}))));